import { reduxForm } from 'redux-form';
import Component from './FormEditBusinessType.jsx';
import { initialValues, validate } from './validate';

export default reduxForm({
  form: 'FormEditBusinessType',
  initialValues,
  validate,
})(Component);
